<template>
  <main class="container">
    <h1 class="title">404 - {{this.$route.fullPath }} Not Found</h1>
  </main>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>

<style lang="scss" scoped>
  .container {
    height: calc(100vh - 18rem);
    @media (max-width: 500px){
      height: calc(100vh - 21rem);
    }
    @media (max-width: 300px){
      height: calc(100vh - 23rem);
    }
    .title {
      text-align: center;
      padding-top: 70px;
    }
  }
</style>
